import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const processSteps = [
  {
    number: "01",
    icon: "ri-search-eye-line",
    title: "Étude & Diagnostic",
    desc: "Analyse complète de votre ouvrage, diagnostic de l'état d'étanchéité existant et conseil personnalisé pour définir la meilleure solution technique adaptée à vos contraintes structurelles et climatiques.",
  },
  {
    number: "02",
    icon: "ri-draft-line",
    title: "Devis & Planning",
    desc: "Élaboration d'un devis transparent et détaillé, accompagné d'un planning précis et du choix des matériaux les mieux adaptés à votre projet.",
  },
  {
    number: "03",
    icon: "ri-tools-line",
    title: "Réalisation des travaux",
    desc: "Exécution des travaux par nos équipes qualifiées, avec des matériaux certifiés adaptés aux contraintes climatiques. Coordination optimale et communication transparente avec nos clients à chaque étape.",
  },
  {
    number: "04",
    icon: "ri-checkbox-circle-line",
    title: "Livraison & Garantie",
    desc: "Réception du chantier avec vous, contrôle d'étanchéité, levée des réserves et remise de la garantie décennale sur l'ensemble de nos ouvrages.",
  },
];

const valeurs = [
  {
    icon: "ri-award-line",
    title: "Qualité sans compromis",
    desc: "Chaque chantier est réalisé dans le respect strict des DTU et des normes en vigueur. Nous n'acceptons aucun compromis sur la qualité des matériaux et de la mise en œuvre.",
  },
  {
    icon: "ri-time-line",
    title: "Respect des délais",
    desc: "Nous établissons un planning précis dès le départ et nous nous engageons à le respecter. Votre chantier est livré dans les délais convenus, sans mauvaise surprise.",
  },
  {
    icon: "ri-discuss-line",
    title: "Communication transparente",
    desc: "Nos chefs de chantier assurent un reporting régulier. Vous êtes informé de l'avancement des travaux à chaque étape, du diagnostic jusqu'à la livraison finale.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Garantie décennale",
    desc: "L'ensemble de nos ouvrages est couvert par une garantie décennale. Vous bénéficiez d'une protection totale sur 10 ans pour tous les travaux d'étanchéité réalisés par KS BTP.",
  },
  {
    icon: "ri-team-line",
    title: "Équipes expérimentées",
    desc: "Nos compagnons sont formés et expérimentés dans toutes les techniques d'étanchéité. Chaque chantier est encadré par un chef de chantier qualifié.",
  },
  {
    icon: "ri-leaf-line",
    title: "Matériaux adaptés",
    desc: "Nous sélectionnons les matériaux les mieux adaptés à chaque projet : membranes bitumineuses, EPDM, résines liquides, isolants thermiques — toujours certifiés et conformes.",
  },
];

const techniques = [
  {
    icon: "ri-fire-line",
    title: "Membranes bitumineuses",
    desc: "Pose de membranes bitumineuses soudées à la flamme ou auto-adhésives, adaptées aux toitures-terrasses, parkings et ouvrages d'art.",
    href: "/services/toitures-terrasses",
  },
  {
    icon: "ri-drop-line",
    title: "Étanchéité liquide",
    desc: "Application de résines et membranes liquides polyuréthane ou époxy pour une étanchéité sans joint, idéale pour les formes complexes.",
    href: "/services/terrasses",
  },
  {
    icon: "ri-shield-line",
    title: "Géomembranes & EPDM",
    desc: "Pose de géomembranes synthétiques EPDM ou PVC pour bassins, réservoirs, piscines et toitures végétalisées.",
    href: "/services/toitures-terrasses",
  },
  {
    icon: "ri-temp-hot-line",
    title: "Isolation thermique",
    desc: "Complexes d'étanchéité avec isolation thermique intégrée (sarking, toiture inversée) pour optimiser les performances énergétiques.",
    href: "/services/etancheite-isolation",
  },
  {
    icon: "ri-road-map-line",
    title: "Asphalte & enrobés",
    desc: "Étanchéité de parkings et dalles carrossables en asphalte coulé, enrobé coulé à froid et résines époxy haute résistance.",
    href: "/services/parkings",
  },
  {
    icon: "ri-refresh-line",
    title: "Réfection & Rénovation",
    desc: "Diagnostic et réfection complète des systèmes d'étanchéité défaillants, avec ou sans dépose de l'existant selon l'état de l'ouvrage.",
    href: "/services/toitures-terrasses",
  },
];

const garanties = [
  { icon: "ri-shield-check-line", label: "Assurance décennale", desc: "Garantie 10 ans sur tous nos ouvrages" },
  { icon: "ri-group-line", label: "Équipes formées", desc: "Personnel qualifié en étanchéité" },
  { icon: "ri-tools-line", label: "Savoir-faire reconnu", desc: "26 ans d'expertise technique" },
  { icon: "ri-trophy-line", label: "Références solides", desc: "500+ chantiers réalisés" },
];

export default function NotreApprochePage() {
  return (
    <div className="min-h-screen bg-white">
    <Navbar />
    <main className="pt-20 bg-white">

      {/* Hero */}
      <section className="relative h-[420px] md:h-[540px] flex items-end overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20waterproofing%20team%20working%20on%20large%20commercial%20rooftop%2C%20experienced%20workers%20in%20safety%20gear%20applying%20bituminous%20membrane%2C%20coordinated%20team%20effort%2C%20wide%20angle%20view%2C%20overcast%20dramatic%20sky%2C%20professional%20BTP%20construction%20photography%2C%20sharp%20details%2C%20impressive%20scale%2C%20industrial%20atmosphere&width=1440&height=900&seq=ksbtp-approche-hero-001&orientation=landscape"
          alt="Notre approche KS BTP"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/20"></div>
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pb-12 md:pb-16">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-green-300 text-xs font-semibold mb-4 hover:text-white transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            Retour à l&apos;accueil
          </Link>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-[#00a340]/60 bg-[#00a340]/15 mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-[#4cd97a] inline-block"></span>
            <span className="text-[#a8f0c0] text-xs font-bold uppercase tracking-widest">Notre méthode</span>
          </div>
          <h1
            className="text-3xl md:text-6xl font-extrabold text-white leading-tight mb-3"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Notre <span className="italic text-[#4cd97a]">approche</span>
          </h1>
          <p className="text-gray-200 text-sm md:text-lg max-w-xl leading-relaxed">
            Rigueur, transparence et engagement — la méthode KS BTP pour des chantiers d&apos;étanchéité réussis, du diagnostic à la livraison.
          </p>
        </div>
      </section>

      {/* Intro Edgar VIGNON */}
      <section className="py-14 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-[#00a340] mb-2 block">À propos de KS BTP</span>
            <h2
              className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-5 leading-tight"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Un engagement total{" "}
              <span className="italic text-[#00a340]">pour vos projets</span>
            </h2>
            <div className="w-12 h-1 bg-[#00a340] rounded-full mb-6"></div>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4 text-justify">
              KS BTP serait particulièrement heureuse et honorée de pouvoir participer dans le cadre de ses compétences à la réalisation de vos projets d&apos;étanchéité. Les <strong className="text-gray-800">matériaux d&apos;étanchéité</strong> que nous utilisons sont parfaitement adaptés à la nature des divers projets et répondent bien aux contraintes climatiques de la région.
            </p>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-6 text-justify">
              KS BTP dispose d&apos;un <strong className="text-gray-800">savoir-faire et d&apos;une expertise reconnue</strong> dans le domaine de l&apos;étanchéité, avec toutes les compétences requises pour réaliser seule vos travaux, avec une bonne coordination et un respect des délais.
            </p>
          </div>

          {/* Image + stats */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden" style={{ height: "400px" }}>
              <img
                src="https://readdy.ai/api/search-image?query=experienced%20construction%20site%20manager%20in%20safety%20vest%20and%20helmet%20overseeing%20waterproofing%20work%20on%20rooftop%2C%20professional%20BTP%20director%2C%20confident%20posture%2C%20urban%20building%20background%2C%20natural%20daylight%2C%20professional%20portrait%20photography%2C%20sharp%20details&width=700&height=800&seq=ksbtp-approche-edgar-001&orientation=portrait"
                alt="Edgar VIGNON - Directeur d'Exploitation KS BTP"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            </div>
            <div className="absolute -bottom-5 -left-5 bg-[#00a340] text-white rounded-xl px-6 py-4 hidden lg:block">
              <div className="text-3xl font-black">26+</div>
              <div className="text-xs text-green-200">Ans d&apos;expertise</div>
            </div>
            <div className="absolute -top-5 -right-5 bg-white border border-gray-100 rounded-xl px-5 py-4 hidden lg:block">
              <div className="text-3xl font-black text-gray-900">500+</div>
              <div className="text-xs text-gray-500">Chantiers réalisés</div>
            </div>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-14 md:py-20 bg-[#f8fdf9]">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-10 md:mb-16">
            <span className="text-xs font-bold uppercase tracking-widest text-[#00a340] mb-2 block">Notre méthode de travail</span>
            <h2
              className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-3"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Un processus{" "}
              <span className="italic text-[#00a340]">rigoureux et maîtrisé</span>
            </h2>
            <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
              De la première prise de contact à la livraison finale, chaque étape est gérée avec méthode et transparence
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {processSteps.map((step) => (
              <div key={step.number} className="relative bg-white rounded-2xl p-6 border border-gray-100 hover:border-[#a8f0c0] transition-colors group">
                <div className="text-6xl font-black text-[#00a340]/8 mb-3 leading-none" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  {step.number}
                </div>
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#e6f7ed] text-[#00a340] mb-4 group-hover:bg-[#00a340] group-hover:text-white transition-colors">
                  <i className={`${step.icon} text-xl`}></i>
                </div>
                <h3 className="font-bold text-gray-900 text-sm md:text-base mb-2">{step.title}</h3>
                <p className="text-gray-500 text-xs md:text-sm leading-relaxed">{step.desc}</p>
                {/* Connector line */}
                <div className="hidden lg:block absolute top-10 -right-4 w-8 h-0.5 bg-[#a8f0c0] last:hidden"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Valeurs */}
      <section className="py-14 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-10 md:mb-16">
            <span className="text-xs font-bold uppercase tracking-widest text-[#00a340] mb-2 block">Ce qui nous distingue</span>
            <h2
              className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-3"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Nos valeurs &amp;{" "}
              <span className="italic text-[#00a340]">engagements</span>
            </h2>
            <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
              Des principes qui guident chacune de nos interventions depuis la création de KS BTP
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {valeurs.map((v) => (
              <div
                key={v.title}
                className="p-6 rounded-2xl border border-gray-100 bg-[#fafafa] hover:border-[#a8f0c0] hover:bg-[#f0fdf4] transition-all group cursor-default"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#e6f7ed] text-[#00a340] mb-4 group-hover:bg-[#00a340] group-hover:text-white transition-colors">
                  <i className={`${v.icon} text-2xl`}></i>
                </div>
                <h3 className="font-bold text-gray-900 text-sm md:text-base mb-2">{v.title}</h3>
                <p className="text-gray-500 text-xs md:text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Techniques */}
      <section className="py-14 md:py-20 bg-[#f8fdf9]">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-10 md:mb-16">
            <span className="text-xs font-bold uppercase tracking-widest text-[#00a340] mb-2 block">Savoir-faire technique</span>
            <h2
              className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-3"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Nos techniques{" "}
              <span className="italic text-[#00a340]">d&apos;étanchéité</span>
            </h2>
            <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
              Des solutions adaptées à chaque type d&apos;ouvrage et aux contraintes spécifiques de votre projet
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {techniques.map((t) => (
              <Link
                key={t.title}
                to={t.href}
                className="p-5 md:p-6 rounded-2xl bg-white border border-gray-100 hover:border-[#a8f0c0] transition-all group cursor-pointer block"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#e6f7ed] text-[#00a340] mb-4 group-hover:bg-[#00a340] group-hover:text-white transition-colors">
                  <i className={`${t.icon} text-2xl`}></i>
                </div>
                <h3 className="font-bold text-gray-900 text-sm md:text-base mb-2">{t.title}</h3>
                <p className="text-gray-500 text-xs md:text-sm leading-relaxed mb-3">{t.desc}</p>
                <span className="inline-flex items-center gap-1 text-[#00a340] text-xs font-semibold group-hover:gap-2 transition-all">
                  En savoir plus <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Garanties & certifications */}
      <section className="py-14 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            {/* Image */}
            <div className="w-full lg:w-1/2 relative">
              <div className="rounded-2xl overflow-hidden" style={{ height: "360px" }}>
                <img
                  src="https://static.readdy.ai/image/8892c16dc9d95083db2eef95f931ffc6/66d6e5a8ec1041ab1a51bb5caea2aaae.png"
                  alt="Garanties et qualifications KS BTP"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-5 left-5 flex gap-2">
                  {["Décennale", "Expertise", "500+ chantiers"].map((cert) => (
                    <div key={cert} className="bg-white/90 backdrop-blur-sm rounded-lg px-3 py-1.5">
                      <span className="text-xs font-black text-gray-800">{cert}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="w-full lg:w-1/2">
              <span className="text-xs font-bold uppercase tracking-widest text-[#00a340] mb-2 block">Garanties &amp; qualifications</span>
              <h2
                className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-4 leading-tight"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                Une entreprise{" "}
                <span className="italic text-[#00a340]">qualifiée et reconnue</span>
              </h2>
              <div className="w-12 h-1 bg-[#00a340] rounded-full mb-5"></div>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-5 text-justify">
                KS BTP est une entreprise <strong className="text-gray-800">sérieuse et professionnelle en étanchéité</strong>, reconnue pour la qualité de ses interventions. Nos garanties assurent à nos clients des prestations conformes aux normes les plus exigeantes du secteur.
              </p>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-6 text-justify">
                Nous travaillons avec les meilleurs fournisseurs de matériaux d&apos;étanchéité — membranes bitumineuses, géomembranes, résines liquides — parfaitement adaptés à la nature des projets et aux contraintes climatiques de la région.
              </p>

              <div className="grid grid-cols-2 gap-3 mb-6">
                {garanties.map((item) => (
                  <div key={item.label} className="flex gap-3 p-4 rounded-xl bg-[#f5fdf8] border border-gray-100 hover:border-[#a8f0c0] transition-colors">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#e6f7ed] text-[#00a340] flex-shrink-0">
                      <i className={`${item.icon} text-base`}></i>
                    </div>
                    <div>
                      <div className="font-bold text-gray-800 text-xs mb-0.5">{item.label}</div>
                      <div className="text-gray-500 text-xs">{item.desc}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex items-start gap-3 p-4 rounded-xl bg-[#e6f7ed] border border-[#a8f0c0]">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#00a340] text-white flex-shrink-0 mt-0.5">
                  <i className="ri-team-line text-sm"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-800 text-sm mb-1">Équipe d&apos;encadrement expérimentée</div>
                  <div className="text-gray-600 text-xs leading-relaxed">
                    Notre équipe de 5 cadres dirigeants et 9 compagnons qualifiés assure un suivi rigoureux de chaque chantier, de l&apos;étude à la livraison.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Composition de l'équipe */}
      <section className="py-14 md:py-20 bg-[#f8fdf9]">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-10 md:mb-16">
            <span className="text-xs font-bold uppercase tracking-widest text-[#00a340] mb-2 block">Notre équipe</span>
            <h2
              className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-3"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Composition de{" "}
              <span className="italic text-[#00a340]">l&apos;entreprise</span>
            </h2>
            <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
              14 personnes engagées au service de la qualité — de l&apos;encadrement aux compagnons sur le terrain
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

            {/* Bloc Cadres */}
            <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
              <div className="flex items-center gap-3 px-6 py-5 border-b border-gray-100 bg-[#0d2b18]">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#00a340] text-white">
                  <i className="ri-briefcase-4-line text-base"></i>
                </div>
                <div>
                  <div className="font-bold text-white text-sm">Encadrement</div>
                  <div className="text-[#4cd97a] text-xs">5 Cadres dirigeants</div>
                </div>
              </div>
              <div className="divide-y divide-gray-50">
                {[
                  { initials: "MK", name: "Mamby Keita", role: "Gérant", icon: "ri-shield-star-line" },
                  { initials: "IF", name: "Isabelle Fernandes", role: "Responsable Comptable & Administratif", icon: "ri-file-list-3-line" },
                  { initials: "EV", name: "Edgar Vignon", role: "Directeur d'Exploitation / Métreur Études", badge: "26 ans d'expérience", icon: "ri-bar-chart-line" },
                  { initials: "IS", name: "Ismael Soulama", role: "Directeur Travaux", icon: "ri-building-line" },
                  { initials: "MS", name: "Mamadi Sacko", role: "Commis Conducteur", icon: "ri-car-line" },
                ].map((p) => (
                  <div key={p.name} className="flex items-center gap-4 px-6 py-4 hover:bg-[#f8fdf9] transition-colors">
                    <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#00a340] text-white font-black text-xs flex-shrink-0">
                      {p.initials}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-bold text-gray-900 text-sm">{p.name}</div>
                      <div className="text-gray-500 text-xs truncate">{p.role}</div>
                    </div>
                    {p.badge && (
                      <span className="flex-shrink-0 bg-[#e6f7ed] text-[#00a340] text-xs font-semibold px-2.5 py-1 rounded-full">{p.badge}</span>
                    )}
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#f5fdf8] text-[#00a340] flex-shrink-0">
                      <i className={`${p.icon} text-sm`}></i>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Bloc Compagnons */}
            <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
              <div className="flex items-center gap-3 px-6 py-5 border-b border-gray-100 bg-[#00a340]">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/20 text-white">
                  <i className="ri-hammer-line text-base"></i>
                </div>
                <div>
                  <div className="font-bold text-white text-sm">Terrain</div>
                  <div className="text-green-100 text-xs">9 Compagnons & Ouvriers qualifiés</div>
                </div>
              </div>

              {/* Chefs de chantier */}
              <div className="px-6 pt-5 pb-3">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded bg-[#e6f7ed] text-[#00a340]">
                    <i className="ri-focus-2-line text-xs"></i>
                  </div>
                  <span className="text-xs font-bold uppercase tracking-wider text-gray-700">4 Chefs de chantier</span>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  {[
                    { initials: "AC", name: "Abdoulaye Camara" },
                    { initials: "MK", name: "Moussa Kanté" },
                    { initials: "JT", name: "Justin Tapena" },
                    { initials: "MD", name: "Mahamadou Diarra" },
                  ].map((p) => (
                    <div key={p.name} className="flex items-center gap-2.5 p-3 rounded-xl bg-[#f5fdf8] border border-gray-100">
                      <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#00a340]/15 text-[#00a340] font-black text-xs flex-shrink-0">
                        {p.initials}
                      </div>
                      <div className="min-w-0">
                        <div className="font-semibold text-gray-900 text-xs truncate">{p.name}</div>
                        <div className="text-gray-400 text-xs">Chef de chantier</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Étanchers */}
              <div className="px-6 pb-6">
                <div className="h-px bg-gray-100 mb-4"></div>
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded bg-[#e6f7ed] text-[#00a340]">
                    <i className="ri-tools-fill text-xs"></i>
                  </div>
                  <span className="text-xs font-bold uppercase tracking-wider text-gray-700">5 Étanchers / Compagnons</span>
                </div>
                <div className="p-4 rounded-xl bg-[#f5fdf8] border border-gray-100">
                  <div className="flex items-start gap-3">
                    <div className="flex -space-x-2 flex-shrink-0">
                      {["01","02","03","04","05"].map((n) => (
                        <div key={n} className="w-8 h-8 flex items-center justify-center rounded-full bg-[#00a340] border-2 border-white text-white text-xs font-black">{n}</div>
                      ))}
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900 text-xs mb-1">Ouvriers qualifiés en étanchéité</div>
                      <div className="text-gray-500 text-xs leading-relaxed">
                        Ce sont ces 9 compagnons qui réalisent concrètement les <strong className="text-gray-700">travaux d&apos;étanchéité sur les chantiers</strong>.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bandeau total */}
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 p-6 rounded-2xl bg-white border border-gray-100">
            {[
              { count: "14", label: "Personnes au total", icon: "ri-group-line", color: "text-[#00a340]" },
              { count: "5", label: "Cadres d&apos;encadrement", icon: "ri-briefcase-4-line", color: "text-[#0d2b18]" },
              { count: "4", label: "Chefs de chantier", icon: "ri-focus-2-line", color: "text-[#00a340]" },
              { count: "5", label: "Étanchers qualifiés", icon: "ri-tools-line", color: "text-[#0d2b18]" },
            ].map((stat, i) => (
              <>
                <div key={stat.label} className="flex items-center gap-3 px-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#f5fdf8]">
                    <i className={`${stat.icon} text-lg ${stat.color}`}></i>
                  </div>
                  <div>
                    <div className="text-2xl font-black text-gray-900" style={{ fontFamily: "'Montserrat', sans-serif" }}>{stat.count}</div>
                    <div className="text-xs text-gray-500" dangerouslySetInnerHTML={{ __html: stat.label }}></div>
                  </div>
                </div>
                {i < 3 && <div className="hidden sm:block w-px h-10 bg-gray-200"></div>}
              </>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-14 md:py-20 bg-[#0d2b18]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-[#4cd97a] mb-3 block">Prêt à démarrer ?</span>
          <h2
            className="text-2xl md:text-4xl font-extrabold text-white mb-4"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Confiez-nous votre projet d&apos;étanchéité
          </h2>
          <p className="text-gray-300 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
            Devis gratuit sous 48h, diagnostic personnalisé et accompagnement complet du début à la fin de votre chantier.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/#contact"
              className="px-8 py-3.5 rounded-md bg-[#00a340] text-white font-semibold text-sm whitespace-nowrap hover:bg-[#007a30] transition-colors cursor-pointer"
            >
              Demander un devis gratuit
            </Link>
            <Link
              to="/services/toitures-terrasses"
              className="px-8 py-3.5 rounded-md border border-white/30 text-white font-semibold text-sm whitespace-nowrap hover:bg-white/10 transition-colors cursor-pointer"
            >
              Voir nos domaines d&apos;expertise
            </Link>
          </div>
        </div>
      </section>

    </main>
    <Footer />
    </div>
  );
}
